import * as React from 'react'
import { Redirect, useLocation } from 'react-router-dom'

import { useKeycloak } from '@react-keycloak/web'
import LoginScreen from '../components/login/LoginScreen'

const LoginPage = () => {
  const location = useLocation<{ [key: string]: unknown }>()
  const currentLocationState = location.state || {
    from: { pathname: '/' },
  }

  const { keycloak } = useKeycloak()

  if (keycloak?.authenticated) return <Redirect to={currentLocationState?.from as string} />

  return <LoginScreen />
}

export default LoginPage
